import React from 'react';
import { useToast } from '../../context/ToastContext';

export const ResultCard = ({ title, subtitle, sections, actions, className = '' }) => {
  const { addToast } = useToast();

  const handleAction = (action) => {
    addToast(`Demo action: ${action}`, 'info');
  };

  return (
    <div className={`bg-white rounded-xl border border-gray-200 overflow-hidden ${className}`}>
      {(title || subtitle) && (
        <div className="px-6 py-4 border-b border-gray-100">
          {title && <h3 className="text-lg font-semibold text-black">{title}</h3>}
          {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
        </div>
      )}
      
      <div className="divide-y divide-gray-100">
        {sections?.map((section, idx) => (
          <div key={idx} className="px-6 py-4">
            {section.title && (
              <div className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3">
                {section.title}
              </div>
            )}
            {section.content}
          </div>
        ))}
      </div>

      {actions && actions.length > 0 && (
        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex flex-wrap gap-2">
          {actions.map((action, idx) => (
            <button
              key={idx}
              onClick={() => handleAction(action.label)}
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                action.primary
                  ? 'bg-[#4a70ff] text-white hover:bg-[#3a5fe6]'
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
              }`}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};